/**
 * SISTEMA: PGLP | MONTE HERMOM
 * COMPONENTE: GestaoCreditoScore_integra
 * LOCALIZAÇÃO: /src/component/admin/faturamento/
 * STATUS: 100% INTEGRAL - INTELIGÊNCIA FINANCEIRA SOBERANA
 */

import React, { useState } from 'react';
import { 
  Diamond, Award, AlertTriangle, ZapOff, 
  CreditCard, Calendar, BarChart, ShieldCheck,
  Mail, Power, Search
} from 'lucide-react';

export default function GestaoCreditoScore_integra() {
  const [peritos] = useState([
    { id: 1, nome: "MARCUS FERRAZ", selo: "DIAMANTE", pontos: 1250, status: "ATIVO", pagamento: "CARTÃO", mrr: 299.90, atraso: 0 },
    { id: 2, nome: "PERITO JOSÉ SILVA", selo: "OURO", pontos: 620, status: "ATIVO", pagamento: "BOLETO", mrr: 299.90, atraso: 2 },
    { id: 3, nome: "ENG. RICARDO SOUZA", selo: "AMBER", pontos: 310, status: "INADIMPLENTE", pagamento: "CARTÃO", mrr: 149.90, atraso: 12 },
    { id: 4, nome: "ANA OLIVEIRA", selo: "FERRO", pontos: 85, status: "SUSPENSO", pagamento: "BOLETO", mrr: 299.90, atraso: 35 },
  ]);

  const renderSeloIcon = (selo) => {
    switch(selo) {
      case 'DIAMANTE': return <Diamond className="text-blue-400" size={18} />;
      case 'OURO': return <Award className="text-amber-500" size={18} />;
      case 'AMBER': return <AlertTriangle className="text-orange-500" size={18} />;
      case 'FERRO': return <ZapOff className="text-slate-400" size={18} />;
      default: return null;
    }
  };

  const getStatusColor = (status) => {
    if (status === 'ATIVO') return 'text-green-600 bg-green-50';
    if (status === 'INADIMPLENTE') return 'text-orange-600 bg-orange-50';
    return 'text-red-600 bg-red-50';
  };

  return (
    <div className="p-10 space-y-10 bg-slate-50 min-h-screen animate-in fade-in duration-700">
      
      {/* HEADER: STATUS DE CRÉDITO DO SISTEMA */}
      <header className="bg-slate-900 rounded-[4rem] p-12 text-white border-b-[12px] border-blue-600 shadow-2xl flex justify-between items-center">
        <div className="flex items-center gap-8">
          <div className="bg-blue-600 p-6 rounded-[2.5rem] shadow-xl">
            <CreditCard size={32} />
          </div>
          <div>
            <h2 className="text-4xl font-black uppercase italic tracking-tighter">Score de Crédito MH</h2>
            <p className="text-[10px] font-black text-blue-400 uppercase tracking-[0.5em]">Gestão de Fidelidade e Hot Storage</p>
          </div>
        </div>
        <div className="flex gap-6">
          <div className="text-right border-r border-white/10 pr-6">
            <span className="block text-[8px] font-black text-slate-500 uppercase tracking-widest">Inadimplência Geral</span>
            <span className="text-3xl font-black text-red-500 italic">14.2%</span>
          </div>
          <div className="text-right">
            <span className="block text-[8px] font-black text-slate-500 uppercase tracking-widest">MRR Ativo</span>
            <span className="text-3xl font-black text-green-500 italic">R$ 18.420</span>
          </div>
        </div>
      </header>

      {/* BUSCA E FILTROS */}
      <div className="flex justify-between items-center px-6">
        <div className="relative w-96">
          <Search className="absolute left-6 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
          <input 
            type="text" 
            placeholder="BUSCAR POR NOME OU SELO..." 
            className="w-full bg-white border-4 border-white shadow-sm py-5 pl-16 pr-8 rounded-full text-[10px] font-black uppercase outline-none focus:border-blue-600 transition-all"
          />
        </div>
        <div className="flex items-center gap-4 italic text-[10px] font-black text-slate-400 uppercase">
          <BarChart size={16} /> Atualizado em: {new Date().toLocaleDateString()}
        </div>
      </div>

      {/* TABELA DE GESTÃO SOBERANA */}
      <div className="bg-white rounded-[5rem] p-12 shadow-luxury border-[15px] border-white overflow-hidden">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b-2 border-slate-50">
              <th className="pb-8 text-[10px] font-black text-slate-400 uppercase tracking-widest">Perito / Histórico</th>
              <th className="pb-8 text-[10px] font-black text-slate-400 uppercase tracking-widest">Selo MH</th>
              <th className="pb-8 text-[10px] font-black text-slate-400 uppercase tracking-widest">Score</th>
              <th className="pb-8 text-[10px] font-black text-slate-400 uppercase tracking-widest">Hot Storage</th>
              <th className="pb-8 text-[10px] font-black text-slate-400 uppercase tracking-widest text-right">Controle</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {peritos.map((p) => (
              <tr key={p.id} className="group hover:bg-slate-50/50 transition-all">
                <td className="py-10">
                  <span className="block font-black text-slate-900 text-sm italic uppercase">{p.nome}</span>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">Pagamento: {p.pagamento}</span>
                    <span className="w-1 h-1 rounded-full bg-slate-300" />
                    <span className="text-[9px] font-bold text-blue-600 uppercase tracking-tighter">R$ {p.mrr}</span>
                  </div>
                </td>
                <td className="py-10">
                  <div className="flex items-center gap-2 px-4 py-2 bg-slate-50 rounded-2xl border border-slate-100 w-fit">
                    {renderSeloIcon(p.selo)}
                    <span className="text-[10px] font-black text-slate-700 uppercase">{p.selo}</span>
                  </div>
                </td>
                <td className="py-10">
                  <div className="flex flex-col">
                    <span className="text-xs font-black text-slate-900">{p.pontos} Pts</span>
                    <div className="w-20 bg-slate-100 h-1.5 rounded-full mt-1 overflow-hidden">
                      <div className="bg-blue-600 h-full" style={{ width: `${(p.pontos/1500)*100}%` }} />
                    </div>
                  </div>
                </td>
                <td className="py-10">
                  <div className={`inline-flex items-center gap-2 px-6 py-2 rounded-full text-[9px] font-black uppercase tracking-widest ${getStatusColor(p.status)}`}>
                    {p.status} {p.atraso > 0 && `(${p.atraso}D)`}
                  </div>
                </td>
                <td className="py-10 text-right">
                  <div className="flex justify-end gap-3 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button className="p-4 bg-slate-100 text-slate-600 rounded-2xl hover:bg-blue-600 hover:text-white transition-all shadow-sm">
                      <Mail size={18} />
                    </button>
                    <button className={`p-4 rounded-2xl transition-all shadow-sm ${p.status === 'SUSPENSO' ? 'bg-green-600 text-white' : 'bg-red-50 text-red-600 hover:bg-red-600 hover:text-white'}`}>
                      <Power size={18} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* FOOTER DE INTEGRIDADE */}
      <footer className="flex justify-between items-center px-10 opacity-40 italic">
        <div className="flex items-center gap-4 text-[9px] font-black text-slate-900 uppercase tracking-widest">
          <ShieldCheck size={18} /> Protocolo de Adimplência Monte Hermom Ativo
        </div>
        <div className="text-[8px] font-black text-slate-400 uppercase">
          Marcus Ferraz Identity • 2026
        </div>
      </footer>
    </div>
  );
}